import { atom } from "jotai";

export const isModifyPromptOpenAtom = atom(false);
isModifyPromptOpenAtom.debugLabel = "isModifyPromptOpenAtom";
